<template>
  <!-- Implementa la schermata di caricamento dell'ordine di Piattapasto
       con relativa finestra di riepilogo per dare seguito o meno a quanto
       caricato.
       Implementa gli eventi:
       - @backToMainMenu: richiesta di tornare al menù principale. -->

  <!-- Overlay di attesa durante il controllo dell'ordine e l'ok all'avvio dello stesso -->
  <CustomOverlay :show="overlay_show" :text="overlay_text">

    <!-- PULSANTE RITORNO AL MENU' PRINCIPALE -->
    <b-row class="mt-5 mb-5">
      <b-col>
        <b-button variant="primary" @click="emit_return_to_menu_event()">
          <b-icon icon="arrow-left-short"></b-icon> Torna al menù
        </b-button>
      </b-col>
    </b-row>

    <!-- FORM DI CARIAMENTO DELL'ORDINE -->
    <b-row>
      <b-col>
        <h4>Caricamento nuovo ordine</h4>
        <p>Per effettuare un nuovo ordine:</p>
        <ol>
          <li>
            <p>Scarica il file di template dell'azienda cliccando qui: <b-button pill variant="primary" size="sm" @click="scarica_template_csv()">Scarica file template</b-button></p>
            <p>Verrà prodotto un file con gli utenti attualmente attivi per l'azienda composto da 4 colonne:</p>
            <ul>
              <li><b>Colonna A:</b> nome e cognome utente</li>
              <li><b>Colonna B:</b> email utente ( <u>non alterare in nessun caso questo campo</u> )</li>
              <li><b>Colonna C:</b> numero dei buoni pasto desiderati</li>
              <li><b>Colonna D:</b> credito attuale utente</li>
            </ul>
          </li>
          <li>
            <p>Compila la <b>Colonna C</b> del file con il numero di buoni richiesti per ciascun utente <b>senza modificare i restanti dati o la struttura stessa del file</b>.</p>
            <p><b>Lascia lo zero o cancella le righe</b> degli utenti che non sono di tuo interesse.</p>
          </li>
          <li>Carica il file tramite il form sottostante e valida l'ordine se le informazioni immesse sono corrette.</li>
          <li>Il sistema prenderà in carico l'ordine non appena possibile, puoi sempre controllarne l'avanzamento nella pagina di stato degli ordini.</li>
        </ol>
        <b-form-file
          :disabled="incomplete_settings"
          v-model="csvfile"
          :state="Boolean(csvfile)"
          accept=".csv"
          placeholder="Scegli un file dal computer cliccando qui sopra oppure trascinalo in questo spazio."
          drop-placeholder="Rilascia qui il file..."
        ></b-form-file>
        <p v-if="incomplete_settings" class="text-danger mt-2">
          Inserisci prima le impostazioni corrette per poter effettuare un ordine
        </p>
        <!-- Il bottone di caricamento ordina compare solo quando viene caricato il file -->
        <b-button v-if="Boolean(csvfile)" variant="danger" class="mt-3" @click="carica_ordine()">
          <b-icon icon="upload"></b-icon> Carica ordine
        </b-button>
      </b-col>
    </b-row>

    <!-- Modale per il riepilogo dei dati caricati per procedere poi all'annullamento o alla conferma dell'ordine -->
    <b-modal v-model="report_modal_show"
              no-close-on-backdrop
              no-close-on-esc
              hide-header-close
              scrollable
              size='lg'
              title="Dati ordine caricati">
      <!-- Corpo della modale: tabella riassuntiva dei dati caricati -->
      <template v-slot:default>
        <p>Verifica i dati caricati quindi prosegui con l'odine od annullalo per procedere ad un nuovo caricamento</p>
        <b-table-simple hover small caption-top responsive>
          <b-thead>
            <b-tr>
              <b-th>Utente</b-th>
              <b-th>Email Utente</b-th>
              <b-th>Buoni Richiesti</b-th>
              <b-th>Importo €</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="( elem, index ) in order_data.data" :key="index">
              <b-td>{{elem.nome}}</b-td>
              <b-td>{{elem.email}}</b-td>
              <b-td>{{elem.nbuoni}}</b-td>
              <b-td>{{elem.val_buoni}}</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-td colspan="2"><b><i>Tot</i></b></b-td>
              <b-td>
                <b><i>{{order_data.buoni_total}}</i></b>
              </b-td>
              <b-td>
                <b><i>{{order_data.order_total}} €</i></b>
              </b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </template>
      <!-- Footer della modale: pulsanti per accettare o rimuovere l'ordine caricato -->
      <template v-slot:modal-footer>
        <b-button size="sm" variant="primary" @click="esegui_ordine()">
          Conferma dati ed esegui l'ordine
        </b-button>
        <b-button size="sm" variant="danger" @click="annulla_ordine()">
          Annulla
        </b-button>
      </template>
    </b-modal>

  </CustomOverlay>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'CaricamentoOrdine',
  data () {
    return {

      // Visualizzazione dell'overlay
      overlay_show: false,

      // Testo dell'overlay: in questo caso sarà
      // diverso a seconda che stiamo verificando
      // l'ordine oppure dando l'ok all'esecuzione
      // per questo richiameremo lo show dell'overlay
      // con dei metodi che setteranno ogni volta
      // il testo giusto.
      overlay_text: "",

      // File csv da caricare per l'odine
      csvfile: null,

      // Flag per visualizzare la modale di riepilogo dell'ordine
      report_modal_show: false,

      // Dati dell'ordine caricati ( il totale dei buoni e dell'importo
      // è calocolato da javascript al momento in cui l'ordine è caricato )
      order_data : {
        order_id : null,
        data: [],
        buoni_total : 0,
        order_total : 0
      }

    }
  },
  methods: {
    /**
     * Emette l'evento backToMainMenu che segnala alla vista
     * la necessità di tornare al menù principale.
     */
    emit_return_to_menu_event : function () {
      this.$emit( 'backToMainMenu' );
    },
    /**
     * Mostra l'overlay con il testo che dice di attendere per lo
     * scaricamento del cvs template per l'ordine.
     */
    show_template_download_overlay : function () {
      this.overlay_text = "Generazione del file in corso, potrebbero essere richiesti alcuni istanti, si prega di attendere...";
      this.overlay_show = true;
    },
    /**
     * Mostra l'overlay con il testo necessario durante il check
     * dell'ordine caricato da csv
     */
    show_order_check_overlay : function () {
      this.overlay_text = "Verifica dati in corso, attendere...";
      this.overlay_show = true;
    },
    /**
     * Mostra l'overlay con il testo relativo alla conferma o meno
     * del proseguo dell'ordine.
     */
    show_order_confirm_overlay : function () {
      this.overlay_text = "Operazione in corso, attendere...";
      this.overlay_show = true;
    },
    /**
     * Resetta i dati dell'ordine precedentemente caricati
     */
    reset_order_data : function () {
      this.order_data.order_id = null;
      this.order_data.data = [];
      this.order_data.buoni_total = 0;
      this.order_data.order_total = 0;
    },
    /**
     * Scarica il template del csv con gli utenti attuamente attivi nell'azienda.
     */
    scarica_template_csv : function () {

      this.show_template_download_overlay();

      axios.get( apiUrl.piattapastoapi.download_template_csv_ordine )
      .then( ( response ) => {
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
        this.overlay_show = false;
      })
      .catch( (error) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Carica l'ordine a sistema e torna il report con la quale poi il
     * referente aziendale gli darà seguito oppure no.
     */
    carica_ordine : function () {

      // Per inviare il file usiamo il multipart perchè così possiamo
      // inviare i dati binari con la classe FormData di javascript cosa
      // che non possiamo fare con il json.
      // Se il file non è presente poniamo come parametro la stringa
      // vuota che lato Django viene riconvertita in None, altrimenti
      // se lascio null, questo viene convertito nella stringa unicode
      // 'null' facendo saltare la validazione lato Django sulla presenza
      // o meno del file.
      let form_data = new FormData();

      if ( this.csvfile === null ) {
        form_data.append( 'csv_ordine' , '' );
      } else {
        form_data.append( 'csv_ordine' , this.csvfile );
      }

      this.show_order_check_overlay();

      axios.post ( apiUrl.piattapastoapi.upload_csv_ordine, form_data,
                  { headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                  }
                ).then( ( response ) => {
                  // Setto i dati relativi all'ordine restituiti
                  // dal backend, resetto l'oggetto file caricato,
                  // tolgo l'overlay e quindi posso visualizzare
                  // la tabella di report nella modale.
                  this.order_data.data = response.data.data;
                  this.order_data.order_id = response.data.order_id;

                  for ( let elem of this.order_data.data ) {
                    this.order_data.order_total += elem.val_buoni;
                    this.order_data.buoni_total += elem.nbuoni;
                  }

                  this.csvfile = null;
                  this.overlay_show = false;
                  this.report_modal_show = true;
                })
                .catch( (error) => {
                  this.csvfile = null;
                  this.overlay_show = false;
                  generalLib.backend_error_message_box( this, error.response.data );
                });

    },
    /**
     * Da il via all'ordine che l'utente ha caricato e visionato tramite la modale.
     */
    esegui_ordine : function () {

      // Se l'ordine viene confermato invochiamo la funzione di backend che avvia
      // le transazioni vera e propria
      let message = "Sei sicuro di procedere all'ordine? L'operazione non potrà essere annullata."
      this.$bvModal.msgBoxConfirm( message )
      .then( ( value ) => {
          if ( value === false ) return;

          // Mostro l'overlay e chiudo la modale.
          this.show_order_confirm_overlay();
          this.report_modal_show = false;

          axios.post( apiUrl.piattapastoapi.conferma_annulla_ordine, { id_ordine : this.order_data.order_id } )
          .then( ( response ) => {
            // La chiamata torna un 204_NO_CONTENT, se tutto ok resetto
            // i dati interni e chiudo l'overlay, visualizzo poi il messaggio
            // di conferma alla chiusura del quale, emetto l'evento di backToMainMenu
            // per indicare alla View principale che voglio tornare al menù principale.
            // di piattapasto.
            this.reset_order_data();
            this.overlay_show = false;

            let message = "L'ordine caricato è stato validato e sarà eseguito non appena possibile.";
            this.$bvModal.msgBoxOk( message, {
              title: 'Azione eseguita',
              centered: true
            })
            .then( ( value ) => {
              this.emit_return_to_menu_event();
            });

          })
          .catch( ( error ) => {
            // Siccome la modale va a chiudersi resettiamo anche i dati
            // dell'ordine.
            this.reset_order_data();
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
          });

      });
    },
    /**
     * Annulla e quindi rimuove l'ordine che l'utente ha caricato e visionato
     * tramite la modale.
     */
    annulla_ordine : function () {

      // Andiamo a rimuovere i dati caricati al backend.
      // Mostriamo quindi l'overlay e chiudiamo la modale.
      this.show_order_confirm_overlay();
      this.report_modal_show = false;

      let call_params = { data: { id_ordine : this.order_data.order_id } };

      axios.delete( apiUrl.piattapastoapi.conferma_annulla_ordine, call_params )
      .then( ( response ) => {
        // La chiamata torna un 204_NO_CONTENT, se tutto ok resetto
        // i dati interni e chiudo l'overlay, visualizzo poi il messaggio
        // di conferma. Qui non torno al menù principale se l'utente vuole
        // effettuare un nuovo caricamento.
        this.reset_order_data();
        this.overlay_show = false;

        this.$bvModal.msgBoxOk( "I dati caricati sono stati rimossi.", {
          title: 'Azione eseguita',
          centered: true
        });

      })
      .catch( ( error ) => {
        // Siccome la modale va a chiudersi resettiamo anche i dati
          // dell'ordine.
        this.reset_order_data();
        this.overlay_show = false;
        // In questo caso non notifichiamo l'errore all'utente,
        // se ho un errore in cancellazione dell'ordine questo non
        // da fastidio e rimane semplicemente nella tabella.
        // Segno quindi l'errore nella console.
        console.error( error.response.data );
      });
    }
  },
  props : {
    /**
     * Omonima proprietà dell'interfaccia principale che
     * ci dice se i settaggi sono stati tutti effettuati
     * o meno.
     */
    incomplete_settings: {
      type: Boolean,
      required: true
    }
  },
  components :{
    CustomOverlay
  }
}

</script>

<style scoped>
</style>